import Modal from "../../scripts/modal";
import SiteMessagesInstance from "../../components/site-messages";
import merge from "lodash.merge";

const modalApproveLinkedAccount = (settings = {}) => {

  settings = merge({
    class: ['group-modal', 'form-modal'],
    title: 'Approve Linked Account',
  }, settings)

  const account = settings.account;
  const modal = new Modal(settings);

  modal.setContent(`

    <form data-form="edit_sub_account" class="grid-container">
    
    <div class="grid-x grid-margin-x form-modal__row">
      <div class="cell medium-2">User</div>
      <div class="cell medium-8">
        <p class="text--bold">${account.email}</p>
        <p class="setting__description">
        You are giving this enterprise account full access to this Temp Stick account
        </p>
      </div>
    </div>
    
    <div class="form-modal-actions">
      <div class="form-modal-actions__submit">
        <button type="submit" class="button" style="margin-right: 20px;" data-for="okay">Approve Link</button>&nbsp;
        <button type="button" class="button gray" data-for="cancel">Cancel</button>
        <div class="error-message">Hello I'm an error</div>
      </div>
    </div>
    </form>
  `);

  const $modalContainer = $(modal.getContainer());

  const $form = $modalContainer.find('form');
  const $error = $modalContainer.find('.error-message');

  $form.on('submit', e => {

    e.preventDefault();
    $form[0].disabled = true;

    $error.removeClass('is-visible');

    const account_name = $modalContainer.find('input[name="account_name"]').val();

    window.apiRequest('post', `/user/linked-accounts/approve/${account.user_id}`).then(async r => {

      $form[0].disabled = false;

      if (r.type === 'error') {

        $error.html(r.message);
        $error.addClass('is-visible');

      } else {
        SiteMessagesInstance.addMessage('success', r.message);
        SiteMessagesInstance.displayMessages();
        modal.close();
      }

    });

  });

  $modalContainer.on('click', '.button[data-for="cancel"]', () => {
    modal.close();
  });

  modal.open();

}

export default modalApproveLinkedAccount;
